export default __webpack_public_path__ + "static/media/Opposites03_09.0c78e72d.png";